'use strict';

module.exports = {
  blank: 'Select a date...',
  headerFormat: 'ddd, MMM Do',
  todayLabel: {
    long: 'Today'
  },
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekStartsOn: 0
};


//////////////////
// WEBPACK FOOTER
// ./~/react-infinite-calendar/lib/utils/defaultLocale.js
// module id = 851
// module chunks = 0